import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

const VALID_KEYS = ["search", "cast[]"]
export default class extends Controller {
  connect() {
  }

  submit(event) {
    event.preventDefault()

    const formData = new FormData(event.target.closest("form"))
    const queryParams = this.#mergedQueryParams(formData)

    console.log("SUBMIT _____")
    console.log(Object.fromEntries(formData))
    console.log(queryParams)
    console.log("END _____")

    Turbo.visit(window.location.pathname + "?" + queryParams.toString())
  }

  #mergedQueryParams(formData) {
    const queryParams = new URLSearchParams(window.location.search)
    const validFormData = VALID_KEYS.map((key) => [key, formData.getAll(key)]).filter(([_, values]) => values.length > 0)
    for (const [key, values] of validFormData) {
      queryParams.delete(key)
      for (const value of values) {
        queryParams.append(key, value)
      }
    }
    return queryParams
  }
}
